import { ReferrerTypeEntity } from '../entities/referrer-type-entity';

export default class State {
  items: Array<ReferrerTypeEntity> = [];

  loaded = false;
}
